/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');

class MaterialsTestInjectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Test'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord()
	{
		const tmpPayloadUUID = this.pict.getUUID();
		//FIXME: I think this event is busted - it works but not in a good way
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${tmpPayloadUUID}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: this is terrible
			const tmpSampleAddress = 'SampleID__Record';
			const tmpViewMarshalDestinationObject = this.pict.resolveStateFromAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination);
			tmpSample = this.pict.manifest.getValueAtAddress(tmpViewMarshalDestinationObject, tmpSampleAddress);
		}
		return tmpSample;
	}

	/**
	 * @param {string} pTestHash - The test hash to register.
	 * @param {string} pSaltHash - The salt hash to register.
	 * @param {(pError?: Error) => void} [fCallback] - Optional callback function to be called after registration.
	 */
	registerTest(pTestHash, pSaltHash, fCallback)
	{
		if (!pTestHash)
		{
			if (typeof fCallback === 'function')
			{
				fCallback();
			}
			return;
		}
		if (!this.pict.providers.DocumentDynamicSectionManager)
		{
			this.pict.log.error(`MaterialsTestInjectorInputType: DocumentDynamicSectionManager provider not available; cannot register test`, { pTestHash });
			if (typeof fCallback === 'function')
			{
				fCallback();
			}
			return;
		}
		this.pict.providers.DocumentDynamicSectionManager.registerTest(pTestHash, pSaltHash, (pViews) =>
		{
			if (Array.isArray(pViews) && pViews.length > 0)
			{
				const tmpSample = this._getBoundSampleRecord();
				if (!tmpSample)
				{
					this.pict.log.warn(`Unable to look up sample record after test injection; skipping data requirement update`, { pTestHash });
					this.pict.PictApplication.solve();
					return;
				}
				this.pict.providers.DataRequirementsProvider.updateDataRequirementsForManifest(this.pict.views.PictFormMetacontroller.manifestDescription, () =>
				{
					this.pict.providers.DataRequirementsProvider.applyDataRequirements(this.pict.views.PictFormMetacontroller.manifestDescription, tmpSample).catch((pError) =>
					{
						this.pict.log.error(`Error applying data requirements after test injection: ${pError.message || pError}`);
					}).finally(() =>
					{
						this.pict.PictApplication.solve(); //FIXME: this may be a second solve, depending on the data requirements outcome
						if (typeof fCallback === 'function')
						{
							fCallback();
						}
					});
				}, [ pTestHash ]);
			}
		});
	}

	/**
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getDefaultRecordIdentity(pInput)
	{
		return 'Hash';
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// kinda weird; we don't want to load the test record from the parent class, but we want most of the other parent behaviors
		return true;
	}

	/**
	 * Handles data requests for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		// kinda weird; we don't want to load the test record from the parent class, but we want most of the other parent behaviors
		return true;
	}

	/**
	 * @param {Record<string, any>} pRecord
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getRecordDisplayName(pRecord, pInput)
	{
		if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
		{
			return '#INVALID#';
		}
		if (!pRecord.Name)
		{
			if (pRecord.Description)
			{
				return pRecord.Description;
			}
			if (pRecord.Hash)
			{
				return `Test Code ${pRecord.Hash}`;
			}
			return `Unnamed Test #${pRecord.IDTest ?? '??'}`;
		}
		return pRecord.Name;
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'Hash', 'Name' ];
		//TODO: wrap existing HandleSearchFilters if it exists?
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			//FIXME: care about wrapping sort instructions...
			if (pFilters.length > 0)
			{
				pFilters.unshift('FOP~0~(~0');
				pFilters.push('FCP~0~)~0');
			}
			pFilters.push('FBV~Active~EQ~1');
			pFilters.push('FBV~Injectable~EQ~1');
			return pFilters;
		};
	}
}

module.exports = MaterialsTestInjectorInputType;
